<template>
  <el-radio-group v-model="checkedList" @change="handleCheckedListChange">
    <div class="box">
      <div class="item" v-for="item in list" :key="item.mate_id">
        <el-popover
          placement="right"
          :title="type === 'public' ? '适用公众号' : '适用企业应用'"
          width="110"
          trigger="hover"
          popper-class="popverClass"
        >
          <template v-if="type === 'public'">
            <div v-for="it in item.apps" :key="it.app_id">
              {{ it.app_name }}
            </div>
          </template>
          <template v-else>
            <div v-for="it in item.agents" :key="it.agent_id">
              {{ it.agent_name }}
            </div>
          </template>
          <div slot="reference" class="music-box">
            <img :src="item.mate_data" alt="" />
            <el-radio class="checkbox" :label="item" :disabled="forbidden" :checked="item.select">
              <span></span>
            </el-radio>
          </div>
        </el-popover>
        <div class="title">{{ item.mate_name }}</div>
      </div>
    </div>
  </el-radio-group>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'public',
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    checkedChange: {
      type: Function,
    },
    forbidden: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      checkedList: [],
    };
  },
  methods: {
    handleCheckedListChange() {
      this.$emit('checkedChange', [this.checkedList]);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-wrap: wrap;
  padding-left: 15px;
}
.item {
  position: relative;
  margin: 5px 8px;
  img {
    width: 137px;
    height: 137px;
    border-radius: 12px;
    border: 1px solid #959595;
  }
  .checkbox {
    position: absolute;
    top: 7px;
    left: 7px;
    z-index: 55;
  }
  .title {
    height: 14px;
    margin: 20px 0;
    color: #303133;
    font-size: 14px;
    width: 137px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
